import '../styles/App.scss'
import Editor from './Editor'

function App(){
    return <div className='App'>
        <Editor/>
        
    </div>
}

export default App